import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

/**
 * Persistent banner shown at the top of the app when the browser goes offline.
 * Automatically hides when connectivity is restored.
 */
export default function OfflineBanner() {
    const isOnline = useNetworkStatus();

    if (isOnline) return null;

    return (
        <div className="offline-banner" role="alert" aria-live="assertive">
            <WifiOff size={14} />
            <span>You're offline. Some features may not work until you reconnect.</span>
        </div>
    );
}
